import { useState, useEffect, useCallback } from 'react'
import { testimonialService, type TestimonialWithId } from '../services/testimonial.service'

interface UseAdminTestimonialsResult {
  pending: TestimonialWithId[]
  approved: TestimonialWithId[]
  rejected: TestimonialWithId[]
  loading: boolean
  refetch: () => void
}

export function useAdminTestimonials(): UseAdminTestimonialsResult {
  const [all, setAll] = useState<TestimonialWithId[]>([])
  const [loading, setLoading] = useState(true)
  const [tick, setTick] = useState(0)

  const refetch = useCallback(() => setTick((t) => t + 1), [])

  useEffect(() => {
    setLoading(true)
    testimonialService
      .getAll()
      .then(setAll)
      .catch(() => setAll([]))
      .finally(() => setLoading(false))
  }, [tick])

  const pending = all.filter((t) => t.status === 'pending')
  const approved = all
    .filter((t) => t.status === 'approved')
    .sort((a, b) => a.order - b.order)
  const rejected = all.filter((t) => t.status === 'rejected')

  return { pending, approved, rejected, loading, refetch }
}
